import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function QCGidYoybuy() {
  return <ArticleLayout slug="qc-gid-yoybuy" />;
}